<div class="linq-page-heading">
	<h2 class="linq-heading">
		{{ title }}
		<button class="mat-icon-button pendo-opener" *ngIf="!hidePendo"><i class="material-icons">info</i></button>
	</h2>
</div>
